import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditWebcamComponent } from '../edit-webcam/edit-webcam.component';
import { DeleteWebcamComponent } from '../delete-webcam/delete-webcam.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var BusinessWebcamsComponent = /** @class */ (function () {
    function BusinessWebcamsComponent(_toggleService, _snackBar, _editWebcamDialog, _deleteWebcamDialog, _businessManagerService) {
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editWebcamDialog = _editWebcamDialog;
        this._deleteWebcamDialog = _deleteWebcamDialog;
        this._businessManagerService = _businessManagerService;
        this.isRegionalManager = false;
    }
    BusinessWebcamsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.editModeSet = this._toggleService.getState();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessWebcamsComponent.prototype.webcamUrl = function (url) {
        var website = url || '';
        if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
            return url;
        }
        else {
            return 'http://' + url;
        }
    };
    BusinessWebcamsComponent.prototype.openEditWebcamDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            businessID: this.business.id,
            webcam: null,
            isNew: false,
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.webcam = this.business.webcams[index];
        dialogConfig.data['busID'] = this.business.id;
        dialogConfig.width = '60%';
        var dialogRef = this._editWebcamDialog.open(EditWebcamComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            // this.reloadAirport(this.business.identifier);
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    // this.airport.pilotControlledLighting.push(isUpdated.pcl);
                    _this.business.webcams.push(isUpdated.webcam);
                    _this._snackBar.open('Webcam', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Webcam', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    BusinessWebcamsComponent.prototype.deleteWebcam = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            businessID: this.business.id,
            webcamId: this.business.webcams[index].webcamId
        };
        var dialogRef = this._deleteWebcamDialog.open(DeleteWebcamComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Webcam', 'Deleted', {
                    duration: 2000
                });
                _this.business.webcams.splice(index, 1);
                // this.reloadAirport(this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return BusinessWebcamsComponent;
}());
export { BusinessWebcamsComponent };
